
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { WindowType } from '../../util';
import DropZone from '../dropzone/DropZone';
import { FolderItem, MediaItem, MediaListModel, MediaType } from '../backend/backendapi';

Vue.use(Toasted, { duration: 2000 });

declare var window: WindowType;

export type SelectCallBack = (e: MediaItem) => void;

@Component({
  name: 'MediaPicker',
  components: {
    DropZone,
  },
})
export default class MediaPicker extends Vue {
  private search: string = '';
  private folderName: string | null = '';
  private listView: boolean = true;
  private currentFolderId: string | null = null;
  private parentFolderId: string | null = null;
  private folders: FolderItem[] = [];
  private items: MediaItem[] = [];
  private folder: { name: string | null } = {
    name: null,
  };
  private filter: MediaType | null = null;
  private callback: SelectCallBack | null = null;
  private filterIsLinkedMedia: boolean = false;

  get canMediaAdd(): boolean {
    return window.application.permissions.media.add;
  }

  get canMediaAddFolder(): boolean {
    return window.application.permissions.media.addFolder;
  }

  get filteredFolders(): FolderItem[] {
    if (!this.search.length) {
      return this.folders;
    }
    return this.folders.filter((item) => {
      if (!item.name) {
        return false;
      }
      return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
    });
  }

  get filteredItems(): MediaItem[] {
    if (!this.search.length) {
      return this.items;
    }
    return this.items.filter((item) => {
      if (!item.filename) {
        return false;
      }
      return item.filename?.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
    });
  }

  mounted(): void {
    $(this.$refs.mediapicker!).on('shown.bs.modal', () => {
      $(this.$refs.mediapickerSearch!).trigger('focus');
    });
  }

  toggle(): void {
    this.listView = !this.listView;
  }

  load(folderId: string | null): void {
    const self = this;

    let url = window.application.baseUrl + 'manager/api/media/list' + (folderId ? '/' + folderId : '') + '/?width=210&height=160';
    if (this.filter) {
      url += '&filter=' + this.filter;
    }
    if (this.filterIsLinkedMedia) {
      url += '&mediafilter=' + 'NotLinked';
    }

    fetch(url)
        .then((response) => response.json())
        .then((result: MediaListModel) => {
          self.currentFolderId = result.currentFolderId ?? null;
          self.parentFolderId = result.parentFolderId ?? null;
          self.folders = result.folders ?? [];
          self.items = result.media ?? [];
          self.listView = result.viewMode === 'list';
          self.search = '';
        })
        .catch(function (error) {
          console.log('error:', error);
        });
  }

  getThumbnailUrl(item) {
    //real thumbnail url, disabled for now
    //return item.altVersionUrl !== null ? item.altVersionUrl : window.application.baseUrl + "manager/api/media/url/" + item.id + "/210/160";

    //fake thumbnail url
    return item.altVersionUrl !== null ? item.altVersionUrl : window.application.baseUrl + 'manager/api/media/url/' + item.id;
  }

  refresh() {
    this.load(this.currentFolderId);
  }

  open(callback: SelectCallBack | null, filter: MediaType | null, folderId: string) {
    this.search = '';
    this.callback = callback;
    this.filter = filter;

    this.load(folderId);

    $(this.$refs.mediapicker!).modal('show');
  }

  openCurrentFolder(callback: SelectCallBack | null, filter: MediaType | null): void {
    this.callback = callback;
    this.filter = filter;

    this.load(this.currentFolderId);

    $(this.$refs.mediapicker!).modal('show');
  }

  closeModal(): void {
    $(this.$refs.mediapicker!).modal('hide');
  }

  //event
  private onDzComplete(file): void {
    if (file.status === 'success') {
      setTimeout(() => {
        (this.$refs.dropzone as DropZone).removeFile(file);
      }, 3000);
    }
  }

  private onDzQueueComplete(): void {
    this.refresh();
  }

  private onEnter() {
    if (this.filteredItems.length == 0 && this.filteredFolders.length == 1) {
      this.load(this.filteredFolders[0].id ?? null);
      this.search = '';
    }

    if (this.filteredItems.length == 1 && this.filteredFolders.length == 0) {
      this.select(this.filteredItems[0]);
    }
  }

  private select(item: MediaItem): void {
    this.$emit('selected', item);
    this.callback?.(JSON.parse(JSON.stringify(item)));
    this.callback = null;
    this.search = '';

    $(this.$refs.mediapicker!).modal('hide');
  }

  saveFolder(): void {
    const self = this;

    if (self.folderName !== '') {
      fetch(window.application.baseUrl + 'manager/api/media/folder/save' + (self.filter ? '?filter=' + self.filter : ''), {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          parentId: self.currentFolderId,
          name: self.folderName,
        }),
      })
          .then((response) => response.json())
          .then((result) => {
            if (result.status.type === 'success') {
              // Clear input
              self.folderName = null;

              self.folders = result.folders;
              self.items = result.media;
            }

            // Push status to notification hub
            // window.application.notifications.push(result.status);
            this.$toasted.info(result.status);
          })
          .catch((error) => {
            console.log('error:', error);
          });
    }
  }
}
